import { ROLES, type Role } from '../constants/roles';

export const PERMISSIONS = {
  VIEW_DASHBOARD_SUMMARY: [ROLES.OWNER, ROLES.ADMIN],
  VIEW_TEAM_MENU: [ROLES.OWNER, ROLES.ADMIN],
  VIEW_CREDIT_MENU: [ROLES.OWNER, ROLES.ADMIN],
  MANAGE_CARD_ACTIONS: [ROLES.OWNER, ROLES.ADMIN],
  EDIT_CARD_METADATA: [ROLES.OWNER, ROLES.ADMIN],
  MANAGE_CARD_LIMIT: [ROLES.OWNER, ROLES.ADMIN],
  VIEW_CARD_TABS: {
    [ROLES.BASIC]: ['asigned'],
    [ROLES.ADMIN]: ['asigned', 'pending', 'traking'],
    [ROLES.OWNER]: ['asigned', 'pending', 'traking'],
  },
  USE_CARD_STATUS_FILTER: [ROLES.OWNER, ROLES.ADMIN],
} as const;

export const hasPermission = (role: string | undefined, feature: keyof typeof PERMISSIONS): boolean => {
  const allowedRoles = PERMISSIONS[feature];
  if (Array.isArray(allowedRoles)) {
    return allowedRoles.includes(role as Role);
  }
  return false;
};

export const isBasic = (role: string | undefined): boolean => role === ROLES.BASIC;
export const isAdmin = (role: string | undefined): boolean => role === ROLES.ADMIN;
export const isOwner = (role: string | undefined): boolean => role === ROLES.OWNER;
